import { OneMedia } from '@prismamedia/one-components';
import { useEditContextForInput } from '@prismamedia/one-crud-react';
import { BasicContainer } from 'components/BasicContainer';
import { MediaInput } from 'components/MediaInput';
import { FC } from 'react';
import { useStyles } from '../../pages/CampaignPage/CampaignEditPage/Generalities/styles';

const formats = [
  { label: 'Logo', value: 'logo' },
  { label: 'Header', value: 'header' },
];

export const HeaderFields: FC = () => {
  const classes = useStyles();

  const { fieldValue, onChange: onInputChange } = useEditContextForInput<
    OneMedia[]
  >('medias');

  return (
    <BasicContainer title="Header">
      <div className={classes.root}>
        <MediaInput
          sx={{ maxWidth: 800 }}
          brandKey="NL"
          medias={fieldValue || []}
          formats={formats}
          setMedias={(updater) => {
            const medias =
              typeof updater === 'function'
                ? updater(fieldValue || [])
                : updater;
            onInputChange(medias);
          }}
        />
      </div>
    </BasicContainer>
  );
};
